function getCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function applyScarcityAbTest() {
  const variant = getCookie("ab_scarcity_bar");
  if (variant !== "on" && variant !== "off") return;

  const target = variant === "on" ? "scarcity-bar" : "days-left";
  document.querySelectorAll(".scarcity-ab-variant").forEach((el) => {
    el.hidden = el.getAttribute("data-variant") !== target;
  });
}
